module.exports = __webpack_public_path__ + "static/media/linjal-min.7a4360fd.png";